import { useState, useEffect } from 'react';
import api from '../services/api';
import { toast } from 'react-hot-toast';

export function useClienteData() {
    const [clientes, setClientes]   = useState([]);
    const [sedes, setSedes]         = useState([]);
    const [equipos, setEquipos]     = useState([]);
    const [servicios, setServicios] = useState([]);
    const [cargando, setCargando]   = useState(true);

    const cargarDatos = async () => {
        try {
            setCargando(true);
            // 2-nov-2026: hasta 2000 (antes 500): con más de 500 trabajos, los clientes viejos salían "Sin servicios"
            const [resCli, resSed, resEqu, resSvc] = await Promise.all([
                api.get('/clientes?page=0&size=2000'),
                api.get('/sedes?page=0&size=500'),
                api.get('/equipos?page=0&size=2000'),
                api.get('/servicios?page=0&size=2000&sort=fechaServicio,desc'),
            ]);
            setClientes(resCli.data.content || resCli.data);
            // 2-nov-2026: sin los lugares dados de baja (por el admin o por la empresa desde su portal) ni los
            // equipos dados de baja. Antes seguían en la ficha y "Eliminar" no hacía nada (ya estaban archivados).
            // La lista de equipos no traía si estaba activo: por eso el filtro de la ficha nunca sacaba ninguno.
            const todasSedes = resSed.data.content || resSed.data;
            const activas = new Set(todasSedes.filter(s => s.activa !== false).map(s => s.id));
            setSedes(todasSedes.filter(s => activas.has(s.id)));
            setEquipos((resEqu.data.content || resEqu.data)
                .filter(e => e.activo !== false && activas.has(e.sedeId ?? e.sede?.id)));
            setServicios(resSvc.data.content || resSvc.data);
        } catch (err) {
            toast.error("Error de conexión al cargar datos");
        } finally {
            setCargando(false);
        }
    };

    useEffect(() => { cargarDatos(); }, []);

    return { clientes, sedes, equipos, servicios, cargando, cargarDatos };
}
